var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstAid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29315 12.1875H4.74699C4.1567 12.1875 3.67652 11.7073 3.67652 11.117V9.60172C3.67652 9.45953 3.56073 9.34375 3.41814 9.34375H1.90323C1.31295 9.34375 0.832764 8.86356 0.832764 8.27328V4.72672C0.832764 4.13644 1.31295 3.65625 1.90323 3.65625H3.41814C3.56073 3.65625 3.67652 3.54047 3.67652 3.39828V1.88297C3.67652 1.29269 4.1567 0.8125 4.74699 0.8125H8.29315C8.88383 0.8125 9.36402 1.29269 9.36402 1.88297V3.39828C9.36402 3.54047 9.4798 3.65625 9.62199 3.65625H11.1369C11.7276 3.65625 12.2078 4.13644 12.2078 4.72672V8.27328C12.2078 8.86356 11.7276 9.34375 11.1369 9.34375H9.62199C9.4798 9.34375 9.36402 9.45953 9.36402 9.60172V11.117C9.36402 11.7073 8.88383 12.1875 8.29315 12.1875Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAid);
export default __webpack_public_path__ + "static/media/FirstAid.8150f714fce4553943d338add58ccc1d.svg";
export { ForwardRef as ReactComponent };